<template>
  <div class="my_box">
    <div class="my_boxtabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="`我的商品（${total}）`"
          name="我的商品"
        ></el-tab-pane>
        <el-tab-pane
          :label="`我的专题（${total2}）`"
          name="我的专题"
        ></el-tab-pane>
        <el-tab-pane
          :label="`我的资源包（${total3}）`"
          name="我的资源包"
        ></el-tab-pane>
        <el-tab-pane
          :label="`我的题库（${total4}）`"
          name="我的题库"
        ></el-tab-pane>
      </el-tabs>
      <div class="my_boxtabsr">
        <!-- <span v-if="activeName==='我的商品'" v-show="status==='show'" @click="status='update'"><i class="el-icon-setting"></i>管理</span>
        <span v-if="activeName==='我的商品'" v-show="status==='update'" @click="status='show'"><i class="el-icon-setting"></i>完成</span> -->
        <span @click="getzylist"><i class="el-icon-time"></i>资源获取记录</span>
      </div>
    </div>
    <div v-show="activeName === '我的商品'">
      <div class="myResources1">
        <div class="myResources1l">
          <el-select
            v-model="listquery.timeBar"
            @change="getList()"
            placeholder="获取时间"
          >
            <el-option label="全部" :value="undefined"> </el-option>
            <el-option label="近七天" value="0"> </el-option>
            <el-option label="近十五天" value="1"> </el-option>
            <el-option label="近三十天" value="2"> </el-option>
            <el-option label="三十天前" value="3"> </el-option>
          </el-select>
          <el-select
            v-model="listquery.buyStatus"
            @change="getList()"
            placeholder="是否购买"
          >
            <el-option label="全部" :value="undefined"> </el-option>
            <el-option label="已购买" value="0"> </el-option>
            <el-option label="未购买" value="1"> </el-option>
          </el-select>
          <el-select
            v-model="listquery.goodsType"
            @change="getList()"
            placeholder="资源类型"
          >
            <el-option label="全部" :value="undefined"> </el-option>
            <el-option
              v-for="(item, index) in goodsTypeList"
              :key="index"
              :label="item.dictLabel"
              :value="item.dictLabel"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="listquery.acquireSource"
            @change="getList()"
            placeholder="获取途径"
          >
            <el-option label="全部" :value="undefined"> </el-option>
            <el-option
              v-for="(item, index) in acquireSourcelist"
              :key="index"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </div>
        <div class="myResources1r">
          <div class="custom-search" style="border: none">
            <input
              type="text"
              class="custom-input"
              placeholder="请输入"
              v-model.trim="listquery.relevanceName"
              @keyup.enter="getList()"
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              class="custom-button"
              @click="getList()"
              >搜索
            </el-button>
          </div>
        </div>
      </div>
      <div
        :class="
          status === 'show' ? 'myResources2' : 'myResources2 myResources2edit'
        "
      >
        <div
          class="myResources2_li"
          v-for="(item, index) in MyResource"
          :key="index"
        >
          <div class="myResources2_liimgbox">
            <el-image
              class="myResources2_liimg"
              @click="toread(item)"
              :src="item.cover || require('@/assets/images/default_img.jpg')"
            ></el-image>
            <span class="scll" v-show="item.isRead === '0'">上次浏览</span>
            <!-- 来源是授权码的时候不显示 -->
            <img
              v-show="item.isBuy === '0' && item.acquireSource != 'lexueCode'"
              class="ygm"
              src="@/assets/icon/ygm_ico.png"
            />
            <img
              class="myResources2_li_close"
              @click="handdelete(item)"
              src="@/assets/icon/close_btn.png"
            />
          </div>
          <div class="myResources2_b" @click="toread(item)">
            <span v-if="item.sourceFile">{{ item.sourceFile }}</span>
            <p class="ellipsis-aRow" :title="item.relevanceName">
              {{ item.relevanceName }}
            </p>
          </div>
          <div
            class="myResources2_botto ellipsis-aRow"
            :title="
              item.acquireSource === 'distribute'
                ? item.sourceName
                : callDictionaries(acquireSourcelist, item.acquireSource)
            "
          >
            来源：{{
              item.acquireSource === "distribute"
                ? item.sourceName
                : callDictionaries(acquireSourcelist, item.acquireSource)
            }}
          </div>
        </div>
        <noData v-show="total === 0"></noData>
      </div>
      <div class="myResources3">
        <div class="pagination-box" v-show="total > 0">
          <el-pagination
            class="ou-pagination"
            background
            hide-on-single-page
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listquery.pageNum"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="listquery.pageSize"
            layout="total, prev, pager, next, sizes, jumper, slot"
            :total="total"
          >
            <el-button @click="getList()" class="ou-page-go">GO</el-button>
          </el-pagination>
        </div>
      </div>
    </div>
    <div v-show="activeName === '我的专题'">
      <div class="myResources1">
        <div class="myResources1l">
          <el-select
            v-model="listquery2.timeBar"
            @change="getList2()"
            placeholder="获取时间"
          >
            <el-option label="全部" :value="undefined"> </el-option>
            <el-option label="近七天" value="0"> </el-option>
            <el-option label="近十五天" value="1"> </el-option>
            <el-option label="近三十天" value="2"> </el-option>
            <el-option label="三十天前" value="3"> </el-option>
          </el-select>
        </div>
        <div class="myResources1r">
          <div class="custom-search" style="border: none">
            <input
              type="text"
              class="custom-input"
              placeholder="请输入"
              v-model.trim="listquery2.relevanceName"
              @keyup.enter="getList2()"
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              class="custom-button"
              @click="getList2()"
              >搜索
            </el-button>
          </div>
        </div>
      </div>
      <div class="demo-card-list">
        <div
          class="demo-commodit-card"
          v-for="(item, index) in MyResourceSubject"
          :key="index"
        >
          <div class="demo-card-imgbox flex-center" @click="tomyDetail(item)">
            <img
              :src="item.cover || require('@/assets/images/default_img.jpg')"
            />
          </div>
          <div class="demo-card-body-box">
            <div class="title ellipsis-aRow" @click="tomyDetail(item)">
              {{ item.relevanceName }}
            </div>
            <div class="demo-card-info">
              <div class="resource ellipsis-aRow">
                共{{ item.resourceNum }}个资源
              </div>
              <!-- <div style="font-size: 14px;">
                {{ item.isBuy==='0'?'已购买':'未购买' }}
              </div> -->
              <div v-if="item.isBuy === '0'" style="font-size: 14px">
                <img
                  v-show="item.isBuy === '0'"
                  class="ygm"
                  src="@/assets/icon/ygm_ico.png"
                />
              </div>
            </div>
            <div class="zhuant_bottom">
              来源：{{
                item.acquireSource === "distribute"
                  ? item.sourceName
                  : callDictionaries(acquireSourcelist, item.acquireSource)
              }}
            </div>
          </div>
        </div>
      </div>
      <noData v-show="total2 === 0"></noData>
      <div style="width: 100%; float: left; display: table">
        <div class="myResources3">
          <div class="pagination-box" v-show="total2 > 0">
            <el-pagination
              class="ou-pagination"
              background
              hide-on-single-page
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="listquery2.pageNum"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="listquery2.pageSize"
              layout="total, prev, pager, next, sizes, jumper, slot"
              :total="total2"
            >
              <el-button @click="getList2()" class="ou-page-go">GO</el-button>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-show="activeName === '我的资源包'">
      <div class="myResources1">
        <div class="myResources1l">
          <el-select
            v-model="listquery3.timeBar"
            @change="getList3()"
            placeholder="获取时间"
          >
            <el-option label="全部" :value="undefined"> </el-option>
            <el-option label="近七天" value="0"> </el-option>
            <el-option label="近十五天" value="1"> </el-option>
            <el-option label="近三十天" value="2"> </el-option>
            <el-option label="三十天前" value="3"> </el-option>
          </el-select>
          <el-select
            v-model="listquery3.acquireSource"
            @change="getList3()"
            placeholder="获取途径"
          >
            <el-option label="全部" :value="undefined"> </el-option>
            <el-option
              v-show="item.dictValue !== 'bookCity'"
              v-for="(item, index) in acquireSourcelist"
              :key="index"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </div>
        <div class="myResources1r">
          <div class="custom-search" style="border: none">
            <input
              type="text"
              class="custom-input"
              placeholder="请输入"
              v-model.trim="listquery3.relevanceName"
              @keyup.enter="getList3()"
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              class="custom-button"
              @click="getList3()"
              >搜索
            </el-button>
          </div>
        </div>
      </div>
      <div class="demo-card-list">
        <div
          class="demo-commodit-card"
          v-for="(item, index) in MyResourceListBundle"
          :key="index"
        >
          <div class="demo-card-imgbox flex-center" @click="tozybDetail(item)">
            <el-image
              class="demo-card-imgbox"
              :src="item.cover || require('@/assets/images/default_img.jpg')"
              fit="contain"
            ></el-image>
          </div>
          <div class="demo-card-body-box">
            <div class="title ellipsis-aRow" @click="tozybDetail(item)">
              {{ item.relevanceName }}
            </div>
            <div class="demo-card-info">
              <div class="resource ellipsis-aRow">
                共{{ item.resourceNum }}个资源
              </div>
              <div v-if="item.isBuy === '0'" style="font-size: 14px">
                <img
                  v-show="item.isBuy === '0'"
                  class="ygm"
                  src="@/assets/icon/ygm_ico.png"
                />
              </div>
            </div>
            <div class="zhuant_bottom">
              来源：{{
                item.acquireSource === "distribute"
                  ? item.sourceName
                  : callDictionaries(acquireSourcelist, item.acquireSource)
              }}
            </div>
          </div>
        </div>
      </div>
      <noData v-show="total3 === 0"></noData>
      <div style="width: 100%; float: left; display: table">
        <div class="myResources3">
          <div class="pagination-box" v-show="total3 > 0">
            <el-pagination
              class="ou-pagination"
              background
              hide-on-single-page
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="listquery3.pageNum"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="listquery2.pageSize"
              layout="total, prev, pager, next, sizes, jumper, slot"
              :total="total3"
            >
              <el-button @click="getList2()" class="ou-page-go">GO</el-button>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-show="activeName === '我的题库'">
      <div
        :class="
          status === 'show' ? 'myResources2' : 'myResources2 myResources2edit'
        "
      >
        <div
          class="myResources2_li"
          v-for="(item, index) in paperGoods"
          :key="index"
        >
          <div class="myResources2_liimgbox">
            <el-image
              class="myResources2_liimg"
              @click="toread(item)"
              :src="item.cover || require('@/assets/images/default_img.jpg')"
            ></el-image>
            <span class="scll" v-show="item.isRead === '0'">上次浏览</span>
            <!-- 来源是授权码的时候不显示 -->
            <img
              v-show="item.isBuy === '0' && item.acquireSource != 'lexueCode'"
              class="ygm"
              src="@/assets/icon/ygm_ico.png"
            />
            <img
              class="myResources2_li_close"
              @click="handdelete(item)"
              src="@/assets/icon/close_btn.png"
            />
          </div>
          <div class="myResources2_b" @click="toread(item)">
            <span v-if="item.sourceFile">{{ item.sourceFile }}</span>
            <p class="ellipsis-aRow" :title="item.relevanceName">
              {{ item.relevanceName }}
            </p>
          </div>
          <div
            class="myResources2_botto ellipsis-aRow"
            :title="
              item.acquireSource === 'distribute'
                ? item.sourceName
                : callDictionaries(acquireSourcelist, item.acquireSource)
            "
          >
            来源：{{
              item.acquireSource === "distribute"
                ? item.sourceName
                : callDictionaries(acquireSourcelist, item.acquireSource)
            }}
          </div>
        </div>
        <noData v-show="total4 === 0"></noData>
        <div style="width: 100%; float: left; display: table">
          <div class="myResources3">
            <div class="pagination-box" v-show="total > 0">
              <el-pagination
                class="ou-pagination"
                background
                hide-on-single-page
                @size-change="handleSizeChange4"
                @current-change="handleCurrentChange4"
                :current-page="listquery4.pageNum"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="listquery4.pageSize"
                layout="total, prev, pager, next, sizes, jumper, slot"
                :total="total4"
              >
                <el-button @click="getList4()" class="ou-page-go">GO</el-button>
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Action ref="Action" @Action="Action"></Action>
    <Actionzy ref="Actionzy"></Actionzy>
  </div>
</template>
<script>
import {
  selectMyResourceListGoods,
  myResourceremove,
  selectMyResourceListSubject,
  selectMyResourceListBundle,
} from "@/api/user/myResources.js";
import {
  teachingAttrList, //字典值
  goodsInfoDetail,
} from "@/api/bookstore/bookstore";
export default {
  data() {
    return {
      activeName: "我的商品",
      MyResource: [],
      MyResourceSubject: [],
      MyResourceListBundle: [],
      listquery: {
        pageNum: 1,
        pageSize: 10,
        timeBar: null,
        buyStatus: null,
        goodsType: null,
        acquireSource: null,
      },
      listquery2: {
        pageNum: 1,
        pageSize: 10,
        timeBar: null,
      },
      listquery3: {
        pageNum: 1,
        pageSize: 10,
        timeBar: null,
        acquireSource: null,
      },
      listquery4: {
        pageNum: 1,
        pageSize: 10,
        resourceType: "bank",
        goodsType: "试卷",
      },
      total: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      status: "show",
      paperGoods: [],
      acquireSourcelist: [], //获取途径字典
      goodsTypeList: [], //资源类型
    };
  },
  watch: {
    $route(route) {
      this.getList();
      this.getList2();
      this.getList3();
      this.getList4();
    },
  },
  components: {
    noData: () => import("@/components/noData.vue"),
    Action: () => import("./components/Action.vue"),
    Actionzy: () => import("./components/Actionzy.vue"),
    errorBookV2: () => import("./components/errorBookV2.vue"),
  },
  created() {
    this.getresource_source(); //获取来源的字典
    this.getoc_resource_file(); //获取资源类型
    this.getList();
    this.getList2();
    this.getList3();
    this.getList4();
  },
  methods: {
    Action() {
      this.getList();
      this.getList2();
      this.getList3();
      this.getList4();
    },
    handleClick() {},
    getresource_source() {
      //来源
      teachingAttrList("resource_source").then((res) => {
        this.acquireSourcelist = res.data;
      });
    },
    getoc_resource_file() {
      //资源类型
      teachingAttrList("oc_resource_file").then((res) => {
        this.goodsTypeList = res.data;
        let index = this.goodsTypeList.findIndex((item) => {
          if (item.dictLabel == "课程") {
            return true;
          }
        });
        this.goodsTypeList.splice(index, 1);
      });
    },
    getzylist() {
      this.$refs.Action.openDialog();
    },
    toDetail(id) {
      this.$router.push({
        path: "/special/specialDetail",
        query: {
          subjectId: id,
        },
      });
    },
    tomyDetail(item) {
      this.$router.push({
        path: "/special/myspecialDetail",
        query: {
          subjectId: item.id,
          resourceType: item.resourceType,
          resource: item.acquireSource,
          relevanceId: item.relevanceId, //业务id
        },
      });
    },
    tozybDetail(item) {
      this.$router.push({
        path: "/user/myresourcesDetail",
        query: {
          subjectId: item.id,
          resourceType: item.resourceType,
          resource: item.acquireSource,
          teachInstId: item.teachInstId,
          relevanceId: item.relevanceId, //业务id
        },
      });
    },
    getList() {
      selectMyResourceListGoods(this.listquery).then((res) => {
        this.MyResource = res.rows;
        this.total = res.total;
        this.$store.commit("SET_MYGOODSNUM", res.total);
      });
    },
    getList2() {
      selectMyResourceListSubject(this.listquery2).then((res) => {
        this.MyResourceSubject = res.rows;
        this.total2 = res.total;
        this.$store.commit("SET_MYSUBJECTNUM", res.total);
      });
    },
    getList3() {
      selectMyResourceListBundle(this.listquery3).then((res) => {
        this.MyResourceListBundle = res.rows;
        this.total3 = res.total;
        this.$store.commit("SET_MYBUNDLENUM", res.total);
      });
    },
    getList4() {
      selectMyResourceListGoods(this.listquery4).then((res) => {
        this.paperGoods = res.rows;
        this.total4 = res.total;
      });
    },
    //每页条数
    handleSizeChange(val) {
      this.listquery.pageSize = val;
      this.getList();
    },
    //当前页面
    handleCurrentChange(val) {
      this.listquery.pageNum = val;
      this.getList();
    },
    //每页条数
    handleSizeChange2(val) {
      this.listquery2.pageSize = val;
      this.getList2();
    },
    //当前页面
    handleCurrentChange2(val) {
      this.listquery2.pageNum = val;
      this.getList2();
    },
    //每页条数
    handleSizeChange3(val) {
      this.listquery3.pageSize = val;
      this.getList3();
    },
    //当前页面
    handleCurrentChange3(val) {
      this.listquery3.pageNum = val;
      this.getList3();
    },
    //每页条数
    handleSizeChange4(val) {
      this.listquery4.pageSize = val;
      this.getList4();
    },
    //当前页面
    handleCurrentChange4(val) {
      this.listquery4.pageNum = val;
      this.getList4();
    },
    toread(item) {
      // console.log(item);
      if (item.goodsType == "train") {
        let url = this.$router.resolve({
          path: "/willingLearn/courseQuestions",
          query: {
            goodsId: item.relevanceId,
          },
        });
        window.open(url.href, "_blank");
      } else if (item.goodsType == "paper") {
        //判断题组类型
        goodsInfoDetail(item.relevanceId).then((res) => {
          if (res.code == 200) {
            if (res.data.sourceList.length > 0) {
              if (res.data.sourceList[0].resourceType == "bank") {
                let url = this.$router.resolve({
                  path: "/bookstore/bookstoreDetail",
                  query: {
                    goodsId: item.relevanceId,
                    goodsType: item.goodsType,
                  },
                });
                window.open(url.href, "_blank");
              } else {
                let url = this.$router.resolve({
                  path: "/bookstore/answer",
                  query: {
                    goodsId: item.relevanceId,
                    relevanceId: item.relevanceId, //业务id
                    resource: item.acquireSource, //来源
                    resourceType: item.resourceType,
                    teachInstId: item.teachInstId,
                    fromType: "/user/myResources",
                  },
                });
                window.open(url.href, "_blank");
              }
            }
          }
        });
      } else {
        let url = this.$router.resolve({
          path: "/onlineReading",
          query: {
            goodsId: item.relevanceId,
            relevanceId: item.relevanceId, //业务id
            resource: item.acquireSource, //来源
            resourceType: item.resourceType,
            typeName: item.isBuy || "", //判断是否能加入书架
            teachInstId: item.teachInstId,
          },
        });
        window.open(url.href, "_blank");
      }
    },
    handdelete(row) {
      console.log(row);
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        myResourceremove({
          id: row.id,
        }).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        });
      });
      console.log(row);
    },
  },
};
</script>

<style scoped>
.my_box {
  width: 100%;
  display: table;
}

.my_boxtabs {
  width: 100%;
  height: 52px;
  float: left;
}

.my_boxtabs ::v-deep .el-tabs__nav-wrap {
  border-bottom: 1px solid #f2f2f2;
  padding: 0 20px;
  height: 52px;
}

.my_boxtabs ::v-deep .el-tabs__item {
  line-height: 52px;
  height: 52px;
}

.my_boxtabsr {
  position: relative;
  float: right;
  margin-right: 30px;
  height: 52px;
  margin-top: -47px;
}

.my_boxtabsr span {
  float: left;
  margin-left: 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
}

.my_boxtabsr span i {
  float: left;
  margin-right: 4px;
  margin-top: 4px;
}

.myResources1 {
  width: 100%;
  float: left;
}

.myResources1l {
  float: left;
}

.myResources1l ::v-deep .el-select {
  width: 100px;
  margin-left: 10px;
  margin-top: 10px;
}

.myResources1l ::v-deep .el-select input {
  font-size: 14px;
  border: 0;
}

.myResources1r {
  float: right;
  margin-top: 15px;
  margin-right: 30px;
}

.myResources2edit .myResources2_li_close {
  display: block !important;
}

.myResources2 {
  width: 100%;
  float: left;
  padding: 0 20px;
  display: flex;
  flex-wrap: wrap;
}

.myResources2 .myResources2_li_close {
  display: none;
}

.myResources2_li {
  width: 150px;
  float: left;
  margin-right: 68px;
  /* margin-bottom: 30px; */
  padding-bottom: 10px;
}

.myResources2_li:nth-child(5n) {
  margin-right: 0;
}

.myResources2_liimgbox {
  width: 150px;
  height: 150px;
  float: left;
  position: relative;
  margin-bottom: 15px;
}

.myResources2_liimg {
  cursor: pointer;
  width: 150px;
  height: 150px;
  border-radius: 6px;
  border: 1px solid #f2f2f2;
  background: #fff;
}

.myResources2_b {
  cursor: pointer;
  width: 100%;
  float: left;
}

.myResources2_b span {
  float: left;
  margin-right: 7px;
  padding: 0 10px;
  height: 24px;
  background: #f9fdff;
  border: 1px solid #0081ce;
  border-radius: 6px;
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0081ce;
}

.myResources2_b p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
.myResources2_b p:hover {
  color: #1690ff;
  text-decoration: underline;
}
.myResources3 {
  float: right;
  margin: 20px;
}

.scll {
  position: absolute;
  left: 2px;
  top: 7px;
  width: 54px;
  height: 24px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 12px 12px 0px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
}

.ygm {
  position: absolute;
  right: 10px;
  bottom: 10px;
  pointer-events: none;
}

.myResources2_li_close {
  position: absolute;
  right: -2px;
  top: 0;
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.demo-card-list {
  padding: 0 25px;
  box-sizing: border-box;
  display: grid;
  width: 100%;
  grid-row-gap: 30px;
  -webkit-column-gap: 20px;
  -moz-column-gap: 20px;
  column-gap: 20px;
  grid-template-columns: repeat(auto-fit, 320px);
}

.demo-card-list .demo-commodit-card {
  position: relative;
  width: 320px;
  height: 350px;
  background: #ffffff;
  -webkit-box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 10%);
  box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 10%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.demo-card-list .demo-commodit-card .demo-card-imgbox {
  width: 320px;
  height: 240px;
  cursor: pointer;
}

.demo-card-list .demo-commodit-card .demo-card-imgbox img {
  /* max-width: 100%;
  max-height: 100%; */
  /* object-fit: cover; */
  width: 100%;
  height: 100%;
}

.demo-card-list .demo-commodit-card .demo-card-body-box {
  padding: 11px 10px 17px 14px;
}

.demo-card-list .demo-commodit-card .demo-card-body-box .title {
  margin-bottom: 12px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  width: 280px;
  cursor: pointer;
}
.demo-card-list .demo-commodit-card .demo-card-body-box .title:hover {
  color: #1690ff;
  text-decoration: underline;
}
.demo-card-list .demo-commodit-card .demo-card-body-box .demo-card-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.demo-card-list
  .demo-commodit-card
  .demo-card-body-box
  .demo-card-info
  .resource {
  max-width: 155px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 5px;
  min-width: 100px;
  height: 28px;
  background: #ffffff;
  border: 1px solid #0081ce;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0081ce;
  text-align: center;
  line-height: 28px;
}

.demo-card-list .demo-commodit-card .demo-card-body-box .demo-card-info .price {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff5353;
}

.demo-card-list
  .demo-commodit-card
  .demo-card-body-box
  .demo-card-info
  .price
  .yprice {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  text-decoration: line-through;
  color: #999999;
}

.myResources2_botto {
  width: 100%;
  float: left;
  font-size: 12px;
  margin-top: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
}

.zhuant_bottom {
  width: 100%;
  float: left;
  font-size: 12px;
  margin-top: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
  margin-bottom: 12px;
}
</style>
